import React from 'react';
const ClientServiceContactUs = (props) => {
    const { location } = props;
    const useHeading = (text) => {
        return React.createElement(`h${props.headingindex}`, { className: 'font__subtitle' }, text);
    };
    return (React.createElement("div", { className: "corporate-locations_location", id: 'location-' + location.ID },
        location.sublocations && React.createElement("p", { className: "sublocation" }, location.sublocations),
        location.name && useHeading(location.name),
        location.info && React.createElement("p", { className: "info", dangerouslySetInnerHTML: { __html: location.info } })));
};
ClientServiceContactUs.defaultProps = {
    headingindex: 3,
};
export default ClientServiceContactUs;
